import './styles.css';

import ComponentButton, { ButtonProps } from 'components/Button';

function Button(props: ButtonProps) {
	return (
		<div className="institutional-button">
			<ComponentButton
				{...props}
				size="small"
				rippleEffect={props.variant !== 'text'}
			/>
		</div>
	);
}

export default Button;
